import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const Inclusive = (props) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="38"
    viewBox="0 0 80 38"
    fill="none">
    <path
      d="M74.1836 6.44204C66.9556 -0.786031 55.2411 -0.78603 48.013 6.35896L26.9934 27.3785C22.6732 31.6988 15.5282 31.6988 11.208 27.2955C9.13095 25.2184 7.96781 22.3937 7.96781 19.4027C7.96781 16.4118 9.13095 13.587 11.2911 11.51C15.6113 7.18978 22.7563 7.18978 27.0765 11.5931L32.643 17.1595L37.794 12.0085L32.1445 6.35896C24.9995 -0.78603 13.285 -0.869113 6.05694 6.27588C-1.08806 13.504 -1.17114 25.3015 6.05694 32.5296C9.54635 36.019 14.1158 37.9299 19.1007 37.9299C24.0856 37.9299 28.7381 36.019 32.2276 32.5296L53.2471 11.51C57.5674 7.18978 64.7124 7.18978 69.0326 11.5931C73.3528 15.9964 73.3528 23.0583 68.9495 27.3785C64.6293 31.6988 57.4843 31.6988 53.164 27.2955L47.5976 21.729L42.4466 26.8801L48.013 32.4465C51.5024 35.9359 56.2381 37.9299 61.1399 37.9299C66.0417 37.9299 70.6942 36.019 74.1836 32.5296C77.673 29.0402 79.5839 24.3876 79.667 19.4858C79.5839 14.584 77.673 9.93146 74.1836 6.44204Z"
      fill="white"
    />
  </SvgIcon>
);

export default Inclusive;
